import type { SupSingleVaultV3, SupStoredFavToken } from "@/types";
import { useMemo } from "react";

import { getAddress } from "viem";

interface useReduceVaultAssetsProps {
  filterChain?: number;
  filterUnauthenticated?: boolean;
  filterNamePattern?: string[];
  vaults?: SupSingleVaultV3[];
}

export function useReduceVaultAssets({ filterChain, filterUnauthenticated = true, filterNamePattern, vaults = [] }: useReduceVaultAssetsProps = {}) {
  return useMemo(
    () =>
      vaults
        .filter(vault => {
          if (filterUnauthenticated && !vault.protocol?.is_authenticated) {
            return false;
          }
          return !["hidden"].includes(vault.visibility);
        })
        .reduce<SupStoredFavToken[]>((acc, vault) => {
          vault.assets.forEach(asset => {
            if (filterChain && Number(vault.chain.id) !== filterChain) {
              return acc;
            }
            if (filterNamePattern && !filterNamePattern.some(name => asset.symbol.toLowerCase().search(name.toLowerCase()) !== -1)) {
              return acc;
            }
            if (!acc.find(item => getAddress(item.tokenAddress) == getAddress(asset.contract_address) && item.chainId == vault.chain.id)) {
              acc.push({
                tokenAddress: getAddress(asset.contract_address),
                tokenImage: asset.image,
                tokenSymbol: asset.symbol,
                chainId: vault.chain.id as number,
              });
            }
          });
          return acc;
        }, []),
    [filterChain, filterNamePattern, filterUnauthenticated, vaults]
  );
}
